// biome-ignore lint/style/noRestrictedImports: We have to import the types, but only here.
import type * as AdyenWeb from '@adyen/adyen-web';
import { useEffect, useState } from 'react';
import { appendScript } from '../helpers/append-script';
import { appendStylesheet } from '../helpers/append-stylesheet';

export type ApiResponse = {
  action?: AdyenWeb.PaymentAction;
  pspReference?: string;
  resultCode: string;
};

export type AdyenState = {
  data: {
    billingAddress: unknown;
    browserInfo: unknown;
    paymentMethod: Record<string, unknown>;
  };
  [key: string]: unknown;
};

export type Core = AdyenWeb.ICore;
export type CoreConfiguration = AdyenWeb.CoreConfiguration;
export type DropinElement = AdyenWeb.Dropin;

declare global {
  interface Window {
    AdyenWeb?: typeof AdyenWeb;
  }
}

/**
 * https://docs.adyen.com/online-payments/release-notes/?title%5B0%5D=Web+Components%2FDrop-in
 */
export const useAdyen = (
  onError: () => void
): [isLoading: boolean, hasLoaded: boolean] => {
  const [state, setState] = useState({ isLoading: false, hasLoaded: false });

  useEffect(() => {
    if (window.AdyenWeb) {
      setState({
        isLoading: false,
        hasLoaded: true,
      });
      return;
    }

    setState({
      isLoading: true,
      hasLoaded: false,
    });

    appendStylesheet(
      'https://checkoutshopper-live.cdn.adyen.com/checkoutshopper/sdk/6.22.0/adyen.css',
      {
        crossorigin: 'anonymous',
        integrity:
          'sha384-PSGNi66eR1EpVWkEpFZt5kUQ0d2GvLKWiYBcIEdfLVU/CliVeoruYAoGET9Ds0V4',
      }
    );

    appendScript(
      'https://checkoutshopper-live.cdn.adyen.com/checkoutshopper/sdk/6.22.0/adyen.js',
      () => {
        setState({
          isLoading: false,
          hasLoaded: Boolean(window.AdyenWeb),
        });
      },
      {
        crossorigin: 'anonymous',
        integrity:
          'sha384-WfiUNFIMZcr3Bkq0qykKk6945hl4Vgt1kr84uXhyH9vPrfvkxgAqbzdtjCpzjhsZ',
        onError: () => {
          onError();
          setState({
            isLoading: false,
            hasLoaded: Boolean(window.AdyenWeb),
          });
        },
      }
    );
  }, []);

  return [state.isLoading, state.hasLoaded];
};
